import React from 'react'
import { motion } from "framer-motion"; 
import datacheck from "../logos/datacheck.png";
import africaCheck from "../logos/africaCheck.png";
import pesacheck from "../logos/pesacheck.png";
import afp from "../logos/afp.png";
import check237 from "../logos/237check.png";
import stopintox from "../logos/stopintox.png";
import rfi from "../logos/rfi.png";
import observateur from "../logos/observateur.png";
import kubarru from "../logos/kubarru.png";
import factoscope from "../logos/factoscope.png";
import stopblablacam from "../logos/stopblablacam.png";
import Laplume from "../logos/laplume.png";
import Datacameroon from "../logos/Datacameroon.png";
import online from "../logos/237online.png";
import camer from "../logos/camer-be.png";
import actu from "../logos/actu-came.png";    
import lejour from "../logos/lejour.png";
import ecomatin from "../logos/ecomatin.png";
import Journalducameroun from "../logos/Journalducameroun.png";
import bbc from "../logos/bbc.png";
import lemonde from "../logos/lemonde.png";
import france from "../logos/france.png";
import { useTranslation } from 'react-i18next';
const SectionFact = () => {
  const logos = [
    datacheck,
    Datacameroon,
    africaCheck,
    pesacheck,
    afp,
    check237,
    stopintox,
    rfi,
    observateur,
    kubarru,
    factoscope,
    stopblablacam,
    Laplume,
    online,
   camer,
   actu,
   lejour,
   ecomatin,
  Journalducameroun,
   bbc,
   lemonde,
   france
  ];
 const {t} = useTranslation();
  return (
    <section className="bg-white py-16 px-6 md:px-20 dark:bg-[#706F6F]">
      {/* Titre animé */}
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2 className="text-4xl md:text-4xl font-bold text-[#42AB3F]">
          {t("sectionFact.title")}
        </h2>
        <motion.p
          className="mt-4 text-3xl md:text-3xl font-bold bg-white inline-block px-4 py-1 rounded-lg shadow dark:text-black"
          initial={{ scale: 0.8, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.3 }}
        >
           {t("sectionFact.title1")}
        </motion.p>
      </motion.div>

      {/* Logos animés */}
      <motion.div
        className="flex flex-wrap items-center justify-center gap-6 mb-16"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        {logos.map((logo, i) => (
          <motion.img
            key={i}
            src={logo}   
            alt={`logo-${i}`}
            className="h-12 w-auto transition-transform duration-300 ease-in-out hover:scale-110 hover:drop-shadow-lg bg-white p-2 rounded-lg"
            initial={{ scale: 0.5, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            viewport={{ once: true }}
          />
        ))}
      </motion.div>
    </section>
  )
}

export default SectionFact
